<div class="ap-container">
  <h2>{{ 'dashboard.title' | translate }}</h2>
  <p>
    {{ 'dashboard.subtitle' | translate }}
    {{ currentDate$ | async | date }}
    {{ currentDate$ | async | date: 'shortTime' }}
  </p>

  <!-- New search pannel -->
  <div class="row mb-2">
    <div class="col-12 py-2 pe-2" style="padding-left: 8px">
      <gstar-global-search variant="full" />
    </div>
  </div>

  <div class="d-flex">
    <div class="col-6 py-2 pe-2">
      <ap-panel class="shadow" [title]="'dashboard.generalRates' | translate">
        <div class="ap-panel-footer d-flex">
          <ap-button
            class="mt-4 px-2"
            btnType="secondary"
            [label]="'dashboard.list' | translate"
            (onClick)="viewSecurities(transactionTypes.GeneralRates)" />
          <ap-button
            class="mt-4"
            icon="plus-outline"
            btnType="primary"
            [label]="'dashboard.new' | translate"
            (onClick)="addSecurities(transactionTypes.GeneralRates)"
            icon="Appkit4-icon icon-plus-outline" />
        </div>
      </ap-panel>
    </div>
    <div class="box" class="col-6 py-2 ps-2">
      <ap-panel
        class="shadow"
        [title]="'dashboard.requestSpecificAdvice' | translate">
        <div class="ap-panel-footer d-flex">
          <ap-button
            class="mt-4 px-2"
            btnType="secondary"
            [label]="'dashboard.list' | translate"
            (onClick)="viewSecurities(transactionTypes.SpecificAdvice)" />
          <ap-button
            class="mt-4"
            btnType="primary"
            icon="plus-outline"
            [label]="'dashboard.new' | translate"
            (onClick)="addSecurities(transactionTypes.SpecificAdvice)" />
        </div>
      </ap-panel>
    </div>
  </div>

  <div class="row mb-2">
    <div class="col-8">
      <gstar-tax-impact-panel />
    </div>
    <div class="col-4 ps-0">
      <gstar-tax-news-panel />
    </div>
  </div>
</div>
